/**
 * Sacred Editorial section divider — replaces <hr>.
 * A thin gold rule with a small mandala/lotus glyph centered.
 */
interface MandalaDividerProps {
  className?: string;
  /** Width of the rules either side of the glyph */
  ruleWidth?: number;
  /** Size of the central glyph in px */
  size?: number;
}

export default function MandalaDivider({
  className = "",
  ruleWidth = 120,
  size = 28,
}: MandalaDividerProps) {
  return (
    <div
      className={`flex items-center justify-center gap-5 text-manuscript/40 ${className}`}
      aria-hidden
    >
      <span
        className="block h-px"
        style={{ width: ruleWidth, background: "hsl(var(--goldleaf) / 0.4)" }}
      />
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="3" fill="currentColor" opacity="0.7" />
        {Array.from({ length: 8 }).map((_, i) => {
          const a = (i * 45 * Math.PI) / 180;
          return (
            <ellipse
              key={i}
              cx={20 + 9 * Math.cos(a)}
              cy={20 + 9 * Math.sin(a)}
              rx="3"
              ry="6"
              transform={`rotate(${i * 45} ${20 + 9 * Math.cos(a)} ${20 + 9 * Math.sin(a)})`}
              stroke="currentColor"
              strokeWidth="0.6"
              fill="none"
            />
          );
        })}
        <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="0.4" opacity="0.4" />
      </svg>
      <span
        className="block h-px"
        style={{ width: ruleWidth, background: "hsl(var(--goldleaf) / 0.4)" }}
      />
    </div>
  );
}
